import cookie from '@/lib/cookie';
import config from '@/config';

const { tokenKey } = config;

export const getToken = () => {
  let token = cookie.get(tokenKey);
  if (!token) {
    token = localStorage.getItem(tokenKey);

  }
  return token;
};

export const setToken = (token) => {
  localStorage.setItem(tokenKey, token);
  cookie.set(tokenKey, token);
};

export const clearToken = () => {
  localStorage.removeItem(tokenKey);
  cookie.remove(tokenKey);
};
